import { ProtoUrl } from 'src/app/@shared/protoUrl';

type ContentBlockType = 'text' | 'rtf' | 'audio' | 'images' | 'video' | 'external' | 'files';
type VideoType = 'youtube' | 'vimeo';
type FileType = 'pdf' | 'other';
type ButtonColor = 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger'
| 'light' | 'medium' | 'dark';

export interface MetaDataSource {
  title?: string;
  description?: string;
  copyright?: string;
}

export interface ProtoMediaSource extends MetaDataSource {
  src: string;
  mimeType?: FileType;
}

export interface ImageSource extends ProtoMediaSource {
  imageId: { id: string };
}

export interface VideoSource extends ProtoMediaSource {
  videoType: VideoType;
}

export interface FileSource extends ProtoMediaSource {
  fileId: string;
}

export interface ExternalLinkSource {
  href: string;
  title: string;
  color?: ButtonColor;
}

interface IContentBlockSource {
  type: ContentBlockType;
}

type RichContent = ProtoMediaSource[] | VideoSource[] | ImageSource[] | FileSource[];

export type ContentBlockSource = IContentBlockSource & {
  type: 'text' | 'rtf';
  primitiveContent: string;
} | {
  type: 'images';
  mediaItems: ImageSource[];
} | {
  type: 'video';
  mediaItems: VideoSource[];
} | {
  type: 'external';
  externalLink: ExternalLinkSource;
} | {
  type: 'files' | 'audio';
  mediaItems: FileSource[];
};

export class ContentBlockModel {
  public id: string;
  public type: ContentBlockType;
  public mediaItems: RichContent;

  public primitiveContent: string;
  public externalLink: ExternalLinkSource;

  constructor(source: ContentBlockSource, index: number) {
    this.id = `block-${index + 1}`;

    switch (source.type) {
      case 'rtf':

      // eslint-disable-next-line no-fallthrough
      case 'text':

      // eslint-disable-next-line no-fallthrough
      case 'external':
        Object.assign(this, source);
        break;

      // TODO: src should already part of FileSource
      case 'files':
        Object.assign(this, source);
        this.mediaItems = source.mediaItems.map((file) => {
          const { fileId, title, mimeType, description, copyright } = file;

          return {
            copyright,
            description,
            mimeType,
            src: ProtoUrl.filesDownload(fileId),
            title,
          };
        });

        break;

      // TODO: src should already part of ImageSource
      case 'images':
        Object.assign(this, source);
        this.mediaItems = source.mediaItems.map((image) => {
          const { imageId, title, description, copyright } = image;

          return {
            copyright,
            description,
            imageId,
            src: ProtoUrl.filesDownload(image.imageId.id),
            title,
          };
        });
        break;

      default:
        console.warn(`Content type not yet in template: ${source.type}`);
        break;
    }
  }
}
